// @ts-nocheck
import { AdjustResult } from '@aloft/toolkit-shared';
import { Typography } from '@aloft/toolkit-sui';

import { generateAdjustResultsSummaryStatistics } from '../utils/generateAdjustResultSummaryStatistics.js';

export const ReconciliationStatistics = ({ results }: { results: AdjustResult[] }) => {
  const { median, average } = generateAdjustResultsSummaryStatistics(results);

  return (
    <Typography variant="body1">{`Median: ${
      median.t === 'absolute' ? median.value.toString(true) : median.value
    }   Average: ${
      average.t === 'absolute' ? average.value.toString(true) : average.value
    }`}</Typography>
  );
};
